import { Alert } from "@op/opds.opux";
import { space } from "@op/opds.tokens";
import { ReactNode } from "react";
import LoadingSpinner from "./LoadingSpinner";

type LoadingWrapperProps = {
  isLoading: boolean;
  error: Error | null;
  children: ReactNode;
};

const LoadingWrapper = ({
  isLoading,
  error,
  children,
}: LoadingWrapperProps) => {
  if (error) {
    return (
      <Alert
        style={{ margin: space.default }}
        type="critical"
        contentType="dynamic"
      >
        {error.message}
      </Alert>
    );
  }
  return <>{isLoading ? <LoadingSpinner /> : children}</>;
};

export default LoadingWrapper;
